import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

//se coloca el index 0 porque no aplica
//se graba desde 1
const operationList = [
  '0-N/A',
  'Venta',
  'Renta',
  'Ambos'
  ]

//se coloca el index 0 porque no aplica
//se graba desde 1
const typeList = [
  '0-N/A',
  'One-to-one',
  'One-to-all'
  ]  

const getProspections = async (dataOrigen, refrescar, api, token, body, config) => {
  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.prospections.length <= 0 || data.startDate !== config.startDate || data.endDate !== config.endDate || refrescar) {
    const response = await axios(configws)
    data = { prospections: base64ToString(response) }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, sort, sortColumn } = config
  /* eslint-enable */

  const dataAsc = data.prospections.sort((a, b) => {
    if (a[sortColumn]) {
      return a[sortColumn] < b[sortColumn] ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(prospection => {

      return (
        (
          (prospection.client.toLowerCase().includes(queryLowered)) ||
          prospection.activity.toLowerCase().includes(queryLowered) ||
          prospection.results.toLowerCase().includes(queryLowered) ||
          prospection.user_id.toLowerCase().includes(queryLowered) ||
          prospection.location.toLowerCase().includes(queryLowered) ||
          operationList[prospection.prospection_operation_type].toLowerCase().includes(queryLowered) ||
          typeList[prospection.prospections_activity_type].toLowerCase().includes(queryLowered) ||
          String(prospection.id_prospection).toLowerCase().includes(queryLowered)
        )
      )
  })

  return [
    200,
    {
      allData      : data.prospections,
      total        : filteredData.length,
      prospections : filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page),
      filterData   : filteredData
    }
  ]  
}

// ------------------------------------------------
// GET: Return list of prospections
// ------------------------------------------------

let dataProspections = JSON.parse(localStorage.getItem("dataProspection")) || { prospections: [], startDate: '', endDate: ''}

mock.onGet('/apps/prospections').reply(async config => {
  const user = getUserData()

  if (config.reset) {
    dataProspections = { prospections: [], startDate: '', endDate: ''}
  }

  let user_id2

  if (user.usercoc.role !== 1) {
    user_id2 = user.usercoc.user_id
  } else {
    user_id2 = ""
  }

  let refresh = false

  if (config.reset) {
    refresh = true
  }

  let office_id2 = user.usercoc.office_id

  if (config.report) {
    refresh = true
    if (config.user_id !== '') {
      user_id2 = config.user_id
    }

    if (config.office_id !== '' && config.office_id !== -1) {
      office_id2 = config.office_id
    }
  }

  const body = {
    page            : 1,
    page_size       : '',
    property_filter : '',
    client_filter   : '',
    date_from       : config.startDate,
    date_to         : config.endDate,
    office_id       : office_id2,
    user_id         : user_id2
  }

  const result = await getProspections(dataProspections, refresh, GetApiCOC('getlistProspection'), user.token, body, config)

  dataProspections = { prospections: result[1].allData, startDate: config.startDate, endDate: config.endDate }

  localStorage.setItem("dataProspection", JSON.stringify(dataProspections))

  return result
})

// ------------------------------------------------
// Post: Add prospection
// ------------------------------------------------
mock.onPost(/\/api\/prospections\/\d+/).reply(async config => {

  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('insertProspection'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})